import { MagicAuth, OAuth } from '@magicdoor/auth';
import { env } from '~/utils/env';

export const getAuthConfig = () => {
  const origin = window.location.origin;
  return {
    appRoot: '/api',
    authRoot: env.authRoot,
    callbackUrl: `${origin}/auth/callback`,
    postLoginUrl: '/account/api-keys',
    clientId: 'company_portal',
  };
};

export const auth = new MagicAuth(getAuthConfig());

auth.on(OAuth.getAccessTokenErrorEvent, () => {
  redirectToAuth();
});

auth.on(OAuth.getAccessTokenEvent, (event) => {
  bffCookie(event.detail);
});

auth.on(OAuth.authChangeEvent, () => {
  authChange();
});

const authChange = () => {
  localStorage.setItem('authChange', Date.now().toString());
};

window.addEventListener('storage', (event) => {
  if (event.key === 'authChange') {
    window.location.reload();
  }
});

export const redirectToAuth = async (redirectUrl?: string) => {
  await auth.logout();
  const authUrl = '/auth/signin?redirect=' + (redirectUrl ?? location.pathname + location.search);
  window.location.replace(authUrl);
  authChange();
};

const bffCookie = async (token: string) => {
  document.cookie = `auth.token=${encodeURIComponent(token)}; expires=${new Date(
    new Date(Date.now() + 1000 * 60 * 60 * 24 * 30) // 30 days
  ).toUTCString()}; path=/; SameSite=Strict; Secure`;
};
